{
    "title-light": "Get In",
    "title-strong": "Touch",
    "contact-form": {
        "form-id": "contact-me-form",
        "field-class": "form-label-group",
        "form-text": "For inquiries, questions or feeback please fill in the form below.",
        "fields": [
            {
                "element": "select",
                "css-id": "reasonInput",
                "css-class": "form-control",
                "placeholder": "Reason",
                "label": "Reason",
                "options": [
                    {
                        "text": "Professional Inquiries",
                        "value": "professional",
                        "selected": true
                    },
                    {
                        "text": "Questions",
                        "value": "questions",
                        "selected": false
                    },
                    {
                        "text": "Feedback",
                        "value": "feedback",
                        "selected": false
                    }
                ]
            },
            {
                "element": "input",
                "type": "text",
                "css-id": "fullNameInput",
                "css-class": "form-control",
                "placeholder": "Full Name",
                "label": "Full Name",
                "required": true
            },
            {
                "element": "input",
                "type": "email",
                "css-id": "emailInput",
                "css-class": "form-control",
                "placeholder": "Email Address",
                "label": "Email Address",
                "required": true
            },
            {
                "element": "input",
                "type": "tel",
                "css-id": "telephoneInput",
                "css-class": "form-control",
                "placeholder": "Phone Number",
                "label": "Phone Number",
                "required": true
            },
            {
                "element": "textarea",
                "rows": "8",
                "css-id": "messageTextarea",
                "css-class": "form-control",
                "placeholder": "Message",
                "label": "Message",
                "required": true
            },
            {
                "element": "button",
                "type": "submit",
                "css-id": "contact-submit-btn",
                "css-class": "btn btn-primary btn-block",
                "text": "Submit"
            }
        ]
    },
    "follow-links": [
        {
            "url": "https://www.linkedin.com/in/ameyrupji/",
            "css-class": "fa-linkedin",
            "handle": "ameyrupji"
        },
        {
            "url": "https://github.com/ameyrupji",
            "css-class": "fa-github",
            "handle": "ameyrupji"
        },
        {
            "url": "https://twitter.com/ameyrupji",
            "css-class": "fa-x-twitter",
            "handle": "ameyrupji"
        }
    ]
}